// Server Component (SSR by default in App Router)

import { generateFAQSchema } from "@/lib/Utility";
import { faqs } from "./data";
import FaqClient from "./FAQClient";
import Script from "next/script";

interface FAQItem {
  question: string;
  answer: string;
}

interface FaqProps {
  FaqArray?: FAQItem[];
  allopen?: boolean;
  button?: React.ReactNode;
}

export default function Faq({ FaqArray, allopen = false, button }: FaqProps) {
  const faqData = FaqArray ?? faqs;
  // ✅ Generate schema on server (better for SEO)
  const FAQSchema = generateFAQSchema(faqData);

  return (
    <>
      <FaqClient FaqArray={faqData} allopen={allopen} button={button} />
      <Script
        id="faq-schema"
        type="application/ld+json"
        strategy="afterInteractive" // or "lazyOnload" if you want it very late
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(FAQSchema).replace(/</g, "\\u003c"),
        }}
      />
    </>
  );
}
